<template>
    <div class='mian boxShadow'>
        <!-- 区域 -->
        <div class="mian-item has-border" v-if="isJob">
            <div class="flex ">
                <p class="mian-item-title ">区域</p>
                <div class="flex mian-item-label">
                    <p :class="cityCode===''?'active':''" @click="handleAreaChange('cityCode','',1)" >不限</p>
                    <p :class="cityCode===item.cityCode?'active':''" 
                    v-for="item in positionArea" :key="item.cityCode"
                    @click="handleAreaChange('cityCode',item,1)">
                        {{ item.cityName }}
                    </p>
                </div>
            </div>
            <div class="subarea">
                <div class="flex mian-item-label" v-if="secondArea.length>0"> 
                    <p :class="formData.locationCode===''?'active':''" @click="handleAreaChange('locationCode','',2)">不限</p>
                    <p v-for="(item) in secondArea" 
                    :key="item.id" 
                    @click="handleAreaChange('locationCode',item,2)"
                    :class="formData.locationCode===item.id?'active':''" >
                        {{ item.name }}
                    </p>
                </div>
                <div class="flex mian-item-label hasBorder" v-if="thirdArea.length>0"> 
                    <p :class="formData.parkCode===''?'active':''" @click="handleAreaChange('parkCode','',3)">不限</p>
                    <p v-for="(item) in thirdArea" 
                    :key="item.parkCode" 
                    @click="handleAreaChange('parkCode',item,3)"
                    :class="formData.parkCode===item.parkCode?'active':''">
                        {{ item.parkName }}
                    </p>
                </div>
            </div>

            <!-- <div class="flex select-area" v-show="checkedSecondAreaText.length>0">
                <p>已选区域</p>
                <div v-for="item in checkedSecondAreaText" :key="item.id" @click="deleteCondition(2)">{{ item.name }} 
                    <i class="el-icon-close"></i> 
                </div>
                <div v-for="item in checkedthirdAreaText" :key="item.parkCode" @click="deleteCondition(3)">
                    {{ item.parkName }}
                    <i class="el-icon-close"></i> 
                </div>
            </div> -->


            <div class="conditions flexBetween" v-show="checkedSecondAreaText.length>0">
                <div class="flex  itemsCenter">
                    <p class="shrink">已选区域</p>
                    <div class="flex flexWarp">
                        <div class="flex shrink conditions-item" v-for="item in checkedSecondAreaText" :key="item.id">
                            <p>{{ item.name }}</p>
                            <div @click="deleteCondition(item,2)">X</div>
                        </div>
                        <div class="flex shrink conditions-item" v-for="item in checkedthirdAreaText" :key="item.parkCode">
                            <p>{{ item.parkName }}</p>
                            <div @click="deleteCondition(item,3)">X</div>
                        </div>
                    </div>
                </div>
                <div class="mian-item-title mian-item-clear" @click="clearSelect(2)">清空已选条件</div>
            </div>
            
        </div>


        <div class="mian-item has-border" v-else>
            <div class="flex itemsCenter">
                <p class="mian-item-title ">区域位置</p>
                <div class="flex mian-item-label">
                    <p :class="cityCode===''?'active':''" @click="handleCompanyItem('cityCode','')">不限</p>
                    <p :class="cityCode===item.cityCode?'active':''" 
                    v-for="item in positionArea" :key="item.cityCode"
                    @click="handleCompanyItem('cityCode',item.cityCode)">
                        {{ item.cityName }}
                    </p>
                </div>
            </div>
        </div>
        <div v-if="isJob">
            <!-- 薪酬 -->
            <!-- <div class="flex mian-item has-border">
                <p class="mian-item-title ">薪酬</p>
                <div class="flex mian-item-label">
                    <p :class="rangeData.Salary===''?'active':''" @click="handleChange('Salary','')">不限</p>
                    <p :class="rangeData.Salary===item.code?'active':''" 
                    v-for="item in salaryList" :key="item.id"
                    @click="handleChange('Salary',item)">
                        {{ item.name }}
                    </p>
                    <div class="flex itemsCenter">
                        <p :class="rangeData.Salary==='customSalary'?'active':''" @click="showCustomInput('Salary','customSalary')">自定义</p>
                        <div v-if="showSalaryInput" class="flex mian-item-label-input">
                            <el-input size="mini" v-model="formData.minSalary" placeholder="薪酬上限" type="number"></el-input>
                            <div class="mian-item-label-text">至</div>
                            <el-input size="mini" v-model="formData.maxSalary" placeholder="薪酬下限" ></el-input>
                            <el-button type="primary" size="mini" @click="searchSalary">搜索</el-button>
                        </div>
                    </div>
                </div>
            </div> -->

            <!-- 更多 -->
            <div class="mian-item flexBetween main-selectop">
                <div class="flex itemsCenter">
                    <p class="mian-item-title ">更多</p>
                    <div class="flex">
                        <el-select 
                        v-model="formData.qualificationsType" size="mini" clearable 
                        placeholder="学历要求" 
                        @change="handleChange('qualificationsType',formData.qualificationsType )" 
                        @clear="clearSelectOption('qualificationsType')">
                            <el-option
                                v-for="item in qualificationsType"
                                :key="item.code"
                                :label="item.name"
                                :value="item.code">
                            </el-option>
                        </el-select>

                        <el-select 
                        v-model="formData.industryType" size="mini" clearable 
                        placeholder="行业类型" 
                        @clear="clearSelectOption('industryType')"
                        @change="handleChange('industryType',formData.industryType )" >
                            <el-option
                                v-for="item in this.industryType"
                                :key="item.code"
                                :label="item.name"
                                :value="item.code">
                            </el-option>
                        </el-select>

                        <!-- <el-select 
                        v-model="formData.positionKind" size="mini" clearable 
                        placeholder="职业类型" 
                        @clear="clearSelectOption('positionKind')"
                        @change="handleChange('positionKind',formData.positionKind )" >
                            <el-option
                                v-for="item in this.positionType"
                                :key="item.code"
                                :label="item.name"
                                :value="item.code">
                            </el-option>
                        </el-select> -->

                        <el-cascader
                            size="mini"
                            placeholder="职业类型"
                            v-model="formData.positionKind"
                            :options="allJob"
                            :props="{ expandTrigger:'hover',value:'code',label:'name'}"
                            @change="handleChange('positionKind',formData.positionKind )">
                        </el-cascader>
                        
                        <el-select 
                        v-model="formData.scaleType" size="mini" clearable 
                        placeholder="企业规模" 
                        @clear="clearSelectOption('scaleType')"
                            @change="handleChange('scaleType',formData.scaleType )" >
                            <el-option
                                v-for="item in scale"
                                :key="item.code"
                                :label="item.name"
                                :value="item.code">
                            </el-option>
                        </el-select> 
                        <el-select 
                        v-model="formData.financingType" size="mini" clearable 
                        placeholder="融资阶段" 
                        @clear="clearSelectOption('financingType')"
                        @change="handleChange('financingType',formData.financingType )" >
                            <el-option
                                v-for="item in this.financingType"
                                :key="item.code"
                                :label="item.name"
                                :value="item.code">
                            </el-option>
                        </el-select>
                        <el-select 
                        v-model="formData.companyType" size="mini" clearable 
                        placeholder="企业性质" 
                        @clear="clearSelectOption('companyType')"
                        @change="handleChange('companyType',formData.companyType )" >
                            <el-option
                                v-for="item in this.companyType"
                                :key="item.code"
                                :label="item.name"
                                :value="item.code">
                            </el-option>
                        </el-select>
                        <el-select 
                        v-model="formData.positionType" size="mini" clearable 
                        placeholder="职位类型" 
                        @clear="clearSelectOption('positionType')"
                        @change="handleChange('positionType',formData.positionType )" >
                            <el-option
                                v-for="item in this.positionType"
                                :key="item.code"
                                :label="item.name"
                                :value="item.code">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="mian-item-title mian-item-clear shrink" @click="clearSelect(1)">清空筛选条件</div>
            </div>
        </div>
        <div v-else class="main-item">
            <div class="flex  has-border">
                <p class="mian-item-title ">行业类型</p>
                <div class="flex mian-item-label">
                    <p :class="formData.industryType===''?'active':''" @click="handleCompanyItem('industryType','')">不限</p>
                    <p :class="formData.industryType===item.code?'active':''" 
                    v-for="item in industryType" :key="item.code"
                    @click="handleCompanyItem('industryType',item.code)">
                        {{ item.name }}
                    </p>
                </div>
            </div>

            <div class="flex has-border itemsCenter">
                <p class="mian-item-title ">融资情况</p>
                <div class="flex mian-item-label">
                    <p :class="formData.financingType===''?'active':''" @click="handleCompanyItem('financingType','')">不限</p>
                    <p :class="formData.financingType===item.code?'active':''" 
                    v-for="item in financingType" :key="item.code"
                    @click="handleCompanyItem('financingType',item.code)">
                        {{ item.name }}
                    </p>
                </div>
            </div>

            <div class="flex has-border">
                <p class="mian-item-title ">企业性质</p>
                <div class="flex mian-item-label">
                    <p :class="formData.companyType===''?'active':''" @click="handleCompanyItem('companyType','')">不限</p>
                    <p :class="formData.companyType===item.code?'active':''" 
                    v-for="item in companyType" :key="item.code"
                    @click="handleCompanyItem('companyType',item.code)">
                        {{ item.name }}
                    </p>
                </div>
            </div>

            <div class="flex" style="padding-top: 8px;">
                <p class="mian-item-title ">公司规模</p>
                <div class="flex mian-item-label">
                    <p :class="formData.scaleType===''?'active':''" @click="handleCompanyItem('scaleType','')">不限</p>
                    <p :class="formData.scaleType===item.code?'active':''" 
                    v-for="item in scale" :key="item.code"
                    @click="handleCompanyItem('scaleType',item.code)">
                        {{ item.name }}
                    </p>
                </div>
            </div>

        </div>


    </div>
  </template>
  
  <script>
  import { mapGetters,mapActions,mapState } from "vuex";
  export default {
    props: {
        isJob:{
            type:Boolean,
            default:false
        },
        datas:{

        }
    },
    data() {
        return {         
           salaryList:[{id:1,code:1,name:'3k以下',min:0,max:3},{id:2,code:2,name:'3k-5k',min:3,max:5}],
           formData:{  //表单数据
             cityCode:'',//城市编码
             parkCode:"",//园区编码
             locationCode:"",//区编码

             qualificationsType:'', //学历
             industryType:"", //行业类型
             positionKind:"",//职位类型
             scaleType:"",// 公司规模
             financingType:"", //融资情况
             companyType:"",//公司类型/性质
             positionType:"",//全职，兼职
            //   minimum:'',  //薪酬最小值
            //   maximum:'',  //薪酬最大值
           },
           rangeData:{  //带有区间属性的数据
              Salary:'',
           },
           showSalaryInput:false,
           selectedCondition:[],//

           checkedSubArea:0, //选中的二级区域id
           checkedthirdArea:[], //选中的三级区域id
           checkedSecondAreaText:[], //选中的二级区域
           checkedthirdAreaText:[], //选中的三级区域
           
        };
    },
    components: {
    },
    async created(){
        // if(this.cityCode){
        //     this.formData.cityCode = this.cityCode;
        //     await this.getSecondArea(this.formData.cityCode);
        // }
        this.getPositionArea();
    },
    computed: {
     
      ...mapGetters([
         "qualificationsType",//学历要求
         "industryType",//行业类型
         "positionType",//职位类型
         "scale",       //公司规模
         "financingType",//融资情况
         "companyType", //公司类型
         'positionType' //职位类型 全职，兼职

      ]),
    
      ...mapState({
        positionArea:state => state.jobs.positionArea,
        secondArea:state => state.jobs.secondArea,
        thirdArea:state => state.jobs.thirdArea,
        cityCode:state => state.jobs.cityCodeText,
        allJob:state => state.jobs.allJob,
      }),

    },
    methods: {
        ...mapActions([
            "getPositionArea",
            "getSecondArea",
            "getThirdArea",
        ]),
       
        // 薪酬，下拉框选择
        handleChange(key,value){
            if(key==='Salary'){
                if(value){
                    this.formData[`min${key}`] = value.min;
                    this.formData[`max${key}`] = value.max;
                    this.rangeData[key] = value.code
                }else{
                    this.formData[`min${key}`] = '';
                    this.formData[`max${key}`] = '';
                    this.rangeData[key] = ''
                }
                this.showSalaryInput=false;
            }else if(key==='positionKind'){
                this.formData[key] = value[value.length-1]

            }else{
                this.formData[key] = value;
            }
            this.$emit("updateFormData",this.formData);
          
        }, 
        // 区域选择
        async handleAreaChange(key,value,type){
                if(type===1){  //点击一级区域
                    this.$store.commit("setState", { key: "secondArea", data:[]});
                    this.$store.commit("setState", { key: "thirdArea", data:[]});
                    this.formData.parkCode='';
                    this.formData.locationCode='';
                    
                    if(value){
                        this.formData[key] = value.cityCode;
                        // await this.getSecondArea(value.cityCode);
                        this.$store.commit("setState",{ key: "cityCodeText", data:value.cityCode})
                    }else{
                        this.formData[key] ="";
                        this.$store.commit("setState",{ key: "cityCodeText", data:""})
                    }
                    this.checkedthirdAreaText=[];
                    this.checkedSecondAreaText=[];

                }else if(type===2){ //点击二级区域
                    this.$store.commit("setState", { key: "thirdArea", data:[]});
                    this.formData.parkCode='';
                    if(value){
                        this.formData[key] = value.id ;
                        this.$set(this.checkedSecondAreaText,0,value);
                        this.checkedthirdAreaText=[];
                        await this.getThirdArea(value.id);
                    }else{
                        this.formData[key]='';
                        this.checkedSecondAreaText=[];
                    }
                }else{ //点击三级区域
                    if(value){
                        this.formData[key] = value.parkCode;
                        // 多选
                        // let idx = this.checkedthirdAreaText.findIndex(item=>item.parkCode===value.parkCode);
                        // idx >-1 ?this.checkedthirdAreaText.splice(idx,1) :this.checkedthirdAreaText.push(value)
                        this.$set(this.checkedthirdAreaText,0,value)
                    }else{
                        this.formData[key] = "";
                        this.checkedthirdAreaText=[];
                    }
                }
                this.$emit("updateFormData",this.formData);
        },
        //显示薪酬自定义输入框
        showCustomInput(key,value){
            this.rangeData[key] = value;
            this.showSalaryInput = true;
        },
        //自定义搜索薪酬
        searchSalary(){
            if(!this.formData.minSalary && !this.formData.maxSalary){
                this.$message({
                    message: '请先输入薪酬！',
                    type: 'warning'
                });
            }
            console.log(this.formData,9999)
            this.$emit("updateFormData",this.formData);
        },
        //清空某一个下拉框的选择条件
        clearSelectOption(key){
            this.formData[key] = "";
            this.$emit("updateFormData",this.formData);
        },
        //清空所有选择条件
        clearSelect(type){
            if(type==1){
                let obj={
                    qualificationsType:"",
                    positionKind:"",
                    scaleType:"",
                    financingType:"",
                    companyType:"",
                    industryType:"",
                    positionType:''
                }
             
                for(let key in obj){
                    this.formData[key] = '';
                }
                console.log(this.formData,888888888)
            }else{
                // this.$store.commit("setState", { key: "secondArea", data:[]});
                this.$store.commit("setState", { key: "thirdArea", data:[]});
                this.formData.parkCode='';
                this.formData.locationCode='';
                this.checkedSecondAreaText=[]; //选中的二级区域
                this.checkedthirdAreaText=[];

                // let keys=['area','Salary'];
                // for(let value of keys){
                //     if(value==='Salary'){
                //         this.formData[[`min${value}`]]='';
                //         this.formData[[`max${value}`]]='';
                //         this.rangeData[value]=''
                //     }else{
                //         this.formData[value] = ''
                //     }  
                // }
                // this.selectedCondition = [];
            }
            this.$emit("updateFormData",this.formData);
        },
        //删除某一项已选条件
        deleteCondition(item,type){
            if(type==2){
                this.checkedSecondAreaText = [];
                this.formData.locationCode='';
                this.formData.parkCode='';
                // this.$store.commit("setState", { key: "secondArea", data:[]});
            }else{
                this.checkedthirdAreaText=[];
                this.formData.parkCode='';
                this.$store.commit("setState", { key: "thirdArea", data:[]});
            }
            this.$emit("updateFormData",this.formData)

            // let idx =  this.selectedCondition.findIndex(item=> item.key === values.key);
            // if(idx > -1){
            //     this.selectedCondition.splice(idx, 1);
            //     if(values.key==='Salary'){
            //         this.formData[[`min${values.key}`]]='';
            //         this.formData[[`max${values.key}`]]='';
            //         this.rangeData[values.key]=''
            //     }else{
            //         this.formData[values.key]=''
            //     }
            //     this.$emit("updateFormData",this.formData);
            // }
        },
        //在招公司查询条件选择
        handleCompanyItem(key,value){
            this.formData[key] = value;
            if(key=='cityCode'){
                this.$store.commit("setState",{ key: "cityCodeText", data:value})
            }
            this.$emit('updateFormData',this.formData)
        }
    },
    watch: {
        cityCode: {
            async handler() {
                if(this.cityCode){
                    await this.getSecondArea(this.cityCode);
                }
            },
            deep: true
        },
       
    }
  };
  </script>
  
  <style lang="less" scoped>
  @mianColor:#287CF3;
  @whiteColor:#fff;
  @mainFontCol:rgba(0,0,0,0.85);
  @secondfontCol:rgba(0,0,0,0.5);
  .mian{
    background: @whiteColor;
    padding: 10px 24px 30px ;
    margin: 30px 0;
    .has-border{
        border-bottom: 1px solid rgba(0, 0, 0, 0.10);
        padding: 8px 0;
    }
    &-item{
       align-items: flex-start;
       color:@mainFontCol;
       transition: all .2s linear;
       padding: 10px 0;
       .el-select{
        padding:8px  20px 8px 0; 
       }
       .el-cascader{
        padding:8px  20px 8px 0; 
       }
       &-title{
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        padding:8px  30px 8px 0; 
        flex-shrink: 0;
       }
       &-clear{
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0,0,0,0.25);
        padding:8px  30px 8px 0; 
        align-self: center;
        cursor: pointer;
        &:hover{
            color: @mianColor;
        }
       }
       &-label{
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0,0,0,0.85);
        flex-wrap: wrap;
        align-items: center;
            p{
                padding:8px  16px 8px 0; 
                cursor: pointer;
            }
            .active{
                color: @mianColor;
            }
            &-text{
                padding: 0 4px;
            }
            &-input{
                align-items: center;
                transition: all .3s linear;
                flex-wrap: nowrap;
                &:hover{
                    background: #FFFFFF;
                    padding: 8px 10px;
                    box-shadow: 0 1px 17px 1px rgba(22, 9, 6, 0.2);
                    border-radius: 6px;
                    .el-button{
                        display: block;
                    }

                }
                .el-button{
                    margin-left: 10px;
                    display: none;
                }
                .el-button--primary {
                    color: #FFF;
                    background-color: @mianColor;
                    border-color: @mianColor;
                }
            }
       }
       .subarea{
        background: #f8f8f8;
        padding: 0 12px;
        border-radius: 4px;
        margin: 4px 0;
        transition: all .2s linear;
        .hasBorder{
            border-top: 1px solid #ececec;
            font-size: 14px;
        }
       }

    }
    .main-selectop{
        flex-wrap: nowrap !important;
    }
    .conditions{
        flex-wrap: nowrap;
        margin-top: 10px;
        align-items: center;
        p{
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: @mainFontCol; 
            padding-right: 10px;
        }
        &-item{
            margin-right: 10px;
            background: @mianColor;
            border-radius: 6px;
            color: @whiteColor;
            font-size: 14px;
            align-items: center;
            transition: all .2s linear;
            cursor: pointer;
            &:hover{
                background: #246FD9;
            }
            p{
                color: @whiteColor;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                line-height: 22px;
                padding: 0 0 0 6px;
            }
            div{
                cursor: pointer;
                padding: 2px 12px;
            }
            
        }
        
    }
  }


  .collect-action {
    margin-left: 3px;
    color: #049cfd;
    cursor: pointer;
    font-size: 14px;
  }
  </style>
  